import React from 'react'
import Modal from 'react-modal';
import CancelButton from '../components/Buttons/CancelButton'
import SaveButton from '../components/Buttons/SaveButton'

Modal.setAppElement('#root')

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    }
};

export default ({
    width = "50rem",
    ...props
}) => {
    return (
        <Modal
            style={customStyles}
            {...props}
        >
            <div className="flex flex-col" style={{ maxWidth: width, minWidth: width }}>
                <span className="text-center py-2 text-blue-900 border-b border-gray-400 font-semibold">{props.title}</span>
                {props.children}
                <div className="flex flex-row-reverse border-t border-gray-400 py-2">
                    <CancelButton
                        text="اغلاق"
                        onClick={props.onClose}
                    />
                    {props.onSave && <SaveButton
                        text="حــفظ"
                        onClick={props.onSave}
                    />}
                </div>
            </div>
        </Modal>
    )
}
